<template>
  <div id="footer" class="container-fluid1">
    <div class="container footer-container">
      <div class="footer-con-left" v-if="$isPC">
        <ul class="left-ul">
          <li class="left-li" v-for="it in footerLeft" :key="it.title">
            <h3 class="text-middle">{{it.title}}</h3>
            <ul>
              <li v-for="jt in it.linkitems" :key="jt.name">
                <!-- <a :href="jt.path" :title="jt.name" style="line-height: 32px; color: #888;">{{ jt.name }}</a> -->
                <router-link :to="jt.path">
                  <span style="line-height: 32px; color: #888;">{{ jt.name }}</span>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div></div>
      <ul class="footer-con-right">
        <li class="right-first">
          <ul>
            <li>
              <p>
                <img style="display: inline;" src="../assets/img/pho.png" alt="手机号">
                <a href="tel:15811035291" class="Conv_DINCondensedC text-large"> Tel: 15811035291</a>
              </p>
            </li>
            <li>
              <p>
                <img style="display: inline;" src="../assets/img/em.png" alt="手机号">
                <a href="mailto:wdb@iceriverbj.com">E-mail: wdb@iceriverbj.com</a>
              </p>
            </li>
            <li>
              <p style="display: flex; align-items: start;">
                <img style="display: inline-block; padding-top: 2px;" src="../assets/img/pos.png" alt="手机号">
                <span style="display: inline-block;">北京市丰台区南四环西路188号16区18号楼弘源·丰恒大厦12层</span>
              </p>
            </li>
          </ul>

        </li>
        <li class="right-second">
          <div class="right-second-qr">
            <img src="../assets/img/qr.jpeg">
            <p class="text-gray height-middle">关注我们</p>
          </div>
        </li>
      </ul>
    </div>
    <!-- <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div>
    <p class="title">公司企业网站模板</p>
    <p class="address_tel_fax">
      <span>地址：公司地址</span>
      <span>Tel：888-888-888</span>
    </p>
    <p class="email_wx">
      <span>邮箱：xxx@163.com</span>
      <span>微信号：xxx</span>
    </p> -->

    <div class="copy" style="text-align: left;">
      <div class="container">
        <a style="color: #fff;" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011402010736" rel="nofollow" target="_blank"><img src="https://gw.alicdn.com/tfs/TB1jwakrbH1gK0jSZFwXXc7aXXa-20-20.png" style="width:15px;height:15px;vertical-align: middle;position: relative;top: -2px; display: inline-block;"> 京公网安备11011402010736号</a>
        <a style="color: #fff;" href="https://beian.miit.gov.cn/" rel="nofollow" target="_blank">京ICP备20017504号-1</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data () {
    return {
      footerLeft: [
        {
          title: '关于我们',
          linkitems: [{
            name: '公司简介',
            path: '/companyintroduction'
          }]
        },
        //  {
        //   title: '线上会议',
        //   linkitems: [{
        //     name: '会议集锦',
        //     path: ''
        //   }]
        // },
        {
          title: '案例展示',
          linkitems: [{
            name: '会务会展',
            path: '/software/smartTown'
          }, {
            name: '展览展示',
            path: '/software/bigData'
          }]
        }, {
          title: '产品服务',
          linkitems: [{
            name: '冰河学术活动管理系统',
            path: '/fuwuware/fuwu1'
          }, {
            name: '现场注册签到平台',
            path: '/fuwuware/fuwu2'
          }, {
            name: '会场幻灯片传输系统',
            path: '/fuwuware/fuwu3'
          }, {
            name: '冰河直播系统',
            path: '/fuwuware/fuwu4'
          }]
        }, {
          title: 'a',
          linkitems: [{
            name: '冰河征文系统',
            path: '/fuwuware/fuwu5'
          }, {
            name: '冰河线下壁报系统',
            path: '/fuwuware/fuwu6'
          }, {
            name: '企业数字营销服务',
            path: '/fuwuware/fuwu7'
          }]
        },
        // , {
        //   title: '新闻动态',
        //   linkitems: [{
        //     name: '行业资讯',
        //     path: ''
        //   }]
        // },
      ]
    };
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #e3edff;
  overflow: hidden;
  text-align: center;
}

.footer-container {
  padding: 10px 0px;
  max-width: 98%;
  display: flex;
}
.footer-con-left {
  width: 60%;
}
.left-ul {
  display: flex;
}
.left-li {
  flex: 1;
  text-align: left;
}
.left-li:nth-child(4) h3 {
  visibility: hidden;
}
.text-middle {
  font-size: 16px;
  margin-bottom: 20px;
  font-weight: 700;
  color: #5f5f5f;
}
.footer-con-right {
  width: 40%;
  margin-top: 18px;
  display: flex;
  border-left: 3px solid #0072f0;
  padding-left: 30px;
}
.right-first {
  width: 75%;
}
.right-first p {
  color: #777777;
  text-align: left;
}
.right-first p a {
  color: #777777;
}
.right-first ul li:nth-child(1) p a {
  /* font-size: 24px; */
}
.right-first ul li:nth-child(2) p a {
  /* font-size: 16px; */
}
.right-second {
  width: 25%;
}
.right-second-qr {
  margin-left: 20px;
  margin-top: 6px;
  /* background: #484848; */
  border-radius: 4px;
  /* padding: 10px; */
  text-align: center;
}
.right-second-qr img {
  width: 100%;
  border: 0;
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.1);
  vertical-align: bottom;
}
.right-second-qr p {
  color: #0072f0;
  line-height: 26px;
  margin: 0;
  font-size: 12px;
}

.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #ffffff;
  font-size: 14px;
  /* margin: 10px 0 10px; */
  /* margin-left: 180px; */
  background-image: url("../assets/img/footerbj.png");
  background-size: 100%;
  height: 60px;
  line-height: 60px;
  /* padding-left: 180px; */
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    padding-left: 10px;
    /* margin: 30px 0 10px; */
  }
  .footer-con-right {
    width: 100%;
    margin-top: 18px;
    display: flex;
    border: none;
    padding: 0 30px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue